import { IAuthContext } from './AuthInterface';

export const authInitialState: IAuthContext = {
  loggedUser: undefined,
  firebaseUser: null,
};
